import { makeSelector } from "../../../testing/index.js";
import { DropdownContentSelectors } from "../DropdownContent/dropdownContent.selectors.js";
const TestingAttrs = {
  dropdownContent: "data-dropdown-content"
};
const SelectBaseSelectors = {
  clearButton: makeSelector(
    "Clear button in dropdown",
    TestingAttrs.dropdownContent,
    DropdownContentSelectors.clearButton
  ),
  applyButton: makeSelector(
    "Apply button in dropdown",
    TestingAttrs.dropdownContent,
    DropdownContentSelectors.applyButton
  ),
  searchInput: makeSelector(
    "Search input in dropdown",
    TestingAttrs.dropdownContent,
    DropdownContentSelectors.searchInput
  )
};
export {
  SelectBaseSelectors,
  TestingAttrs
};
